import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { ListItemIcon, ListItemText, useMediaQuery } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import LazyLoader from "../../LazyLoader";

const CardViewResumo = ({ columns, data, hasBotoes }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [visibleItems, setVisibleItems] = useState([]);
  const [loadedChunks, setLoadedChunks] = useState(0);
  const CHUNK_SIZE = 10;
  const minDesktop = useMediaQuery("(max-width: 951px)");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setLoadedChunks(0);
    setVisibleItems([]);
  }, [data]);

  useEffect(() => {
    if (data.length > 0) {
      const endIndex = Math.min((loadedChunks + 1) * CHUNK_SIZE, data.length);
      const newItems = data.slice(0, endIndex);
      setVisibleItems(newItems);
    }
  }, [data, loadedChunks]);

  const loadMoreItems = () => {
    if (visibleItems.length < data.length) setLoadedChunks((prev) => prev + 1);
  };

  return (
    <div className={styles.gridContainer}>
      <Grid
        container
        spacing={2}
        justifyContent={`${minDesktop ? "center" : "space-between"}`}
      >
        {visibleItems.map((item, index) => (
          <Grid key={index} item sx={4}>
            <LazyLoader
              onVisible={
                index === visibleItems.length - 1 ? loadMoreItems : null
              }
            >
              <div
                className={styles.card}
                style={{
                  height: `${columns.length * 28 + (hasBotoes ? 44 : 0)}px`,
                }}
              >
                <div className={styles.header}></div>
                {columns.map((column, i) => (
                  <div key={i}>
                    <span className={styles.itemCard}>
                      {column.label}:{" "}
                      {typeof item[column.key] === "function"
                        ? item[column.key]()
                        : item[column.key]}
                    </span>
                    <br />
                  </div>
                ))}
                {hasBotoes && (
                  <>
                    <div className={styles.containerBtn}>
                      {item.btn.length === 1 ? (
                        <Button
                          className={styles.btnDropdown}
                          fullWidth
                          onClick={() => item?.btn[0]?.onClick()}
                        >
                          {item?.btn[0]?.icon} {item?.btn[0]?.title}
                        </Button>
                      ) : (
                        <>
                          <Button
                            className={styles.btnDropdown}
                            fullWidth
                            onClick={handleClick}
                          >
                            <TuneIcon />
                            Opções
                          </Button>
                          <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            slotProps={{ paper: { style: { width: "25rem" } } }}
                          >
                            {item?.btn?.map((button, index) => (
                              <MenuItem
                                key={index}
                                onClick={() => button.onClick()}
                              >
                                <ListItemIcon>{button?.icon}</ListItemIcon>
                                <ListItemText>{button?.title}</ListItemText>
                              </MenuItem>
                            ))}
                          </Menu>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </LazyLoader>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default CardViewResumo;
